import React from 'react';
import { motion } from 'framer-motion';
import { Stars } from './Stars';
import { REVIEWS } from '../data/content';
export function Reviews() {
  return <section className="px-5 py-10" data-id="element-138">
      <div className="mx-auto max-w-md space-y-4" data-id="element-139">
        {REVIEWS.map((r, i) => <motion.figure key={i} initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.4,
        delay: i * 0.05
      }} className="rounded-xl border border-white/10 bg-[#111]/90 p-4" data-id="element-140">
            <Stars data-id="element-141" />
            <blockquote className="mt-3 text-[15px] leading-snug text-neutral-200" data-id="element-142">
              "{r.text}"
            </blockquote>
            <figcaption className="mt-3 text-sm font-600 text-white" data-id="element-143">
              {r.name}{' '}
              <span className="font-400 text-neutral-400" data-id="element-144">· {r.city}</span>
            </figcaption>
          </motion.figure>)}
      </div>
    </section>;
}